import config from '@/config';
import api from '@/shared/api';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import { useEffect } from 'react';
import moment from 'moment';
import { IntraCompanyQueryKey } from './queryKey';
export const useGetIntraCompanyOverview = (filters) => {
    const intl = useIntl();
    const queryClient = useQueryClient();
    // const [data,setData]=useState();
    const { data, isLoading, error, refetch } = useQuery([IntraCompanyQueryKey.Overview], ({ signal }) => api.base
        .get(`${config.appUrls.api}/api/IntraCompany`, {
        params: Object.assign(Object.assign({}, filters), { dateFrom: filters.dateFrom ? moment(filters.dateFrom).toISOString() : null, dateUntil: filters.dateUntil ? moment(filters.dateUntil).toISOString() : null }),
        signal,
    })
        .then(res => {
        var _a;
        return (_a = res.data) === null || _a === void 0 ? void 0 : _a.map(x => (Object.assign(Object.assign({}, x), { key: `${x.relationCompanyId};${x.userCompanyId}` })));
    }), {
        enabled: true,
        onError: apiError => {
            handleHttpError(intl)(apiError);
        },
        retry: false,
    });
    const reload = () => {
        const detailsQueryKey = [IntraCompanyQueryKey.Details];
        const queryKey = [IntraCompanyQueryKey.Overview];
        queryClient.cancelQueries(queryKey);
        queryClient.removeQueries({ queryKey });
        queryClient.cancelQueries(detailsQueryKey);
        queryClient.removeQueries({ queryKey: detailsQueryKey });
        return refetch();
    };
    const setIsProcessing = (keys, isProcessing = true) => {
        queryClient.setQueriesData([IntraCompanyQueryKey.Overview], oldData => {
            return oldData.map(x => (keys.includes(x.key) ? Object.assign(Object.assign({}, x), { isProcessing }) : x));
        });
    };
    // Reload if filters change
    useEffect(() => {
        reload();
    }, [filters]);
    return {
        data,
        error,
        isLoading,
        reload,
        setIsProcessing,
    };
};
